import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ArticlePage from './pages/ArticlePage';
import CategoryPage from './pages/CategoryPage';
import PhotoArchives from './pages/PhotoArchives';
import FiftyYears from './pages/FiftyYears';
import SubscribePage from './pages/SubscribePage';
import EPapersPage from './pages/EPapersPage';
import EPaperSearchPage from './pages/EPaperSearchPage';
import CitizenReporter from './pages/CitizenReporter';
import PublicationsPage from './pages/PublicationsPage';
import { AdminAuthProvider } from './context/AdminAuthContext';
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './components/admin/Dashboard';
import ArticleManagement from './components/admin/ArticleManagement';
import GalleryManagement from './components/admin/GalleryManagement';
import EPaperManagement from './components/admin/EPaperManagement';
import BreakingNewsManager from './components/admin/BreakingNewsManager';
import WebsiteSettings from './components/admin/WebsiteSettings';
import SubscriberManagement from './components/admin/SubscriberManagement';
import CitizenReportsManagement from './components/admin/CitizenReportsManagement';
import AdvertisementManagement from './components/admin/AdvertisementManagement';
import PublicationsManagement from './components/admin/PublicationsManagement';
import Analytics from './components/admin/Analytics';
import ProtectedRoute from './components/admin/ProtectedRoute';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/category/:category" element={<CategoryPage />} />
            <Route path="/photo-archives" element={<PhotoArchives />} />
            <Route path="/50-years" element={<FiftyYears />} />
            <Route path="/subscribe" element={<SubscribePage />} />
            <Route path="/epaper" element={<EPapersPage />} />
            <Route path="/epaper/search" element={<EPaperSearchPage />} />
            <Route path="/citizen-reporter" element={<CitizenReporter />} />
            <Route path="/publications" element={<PublicationsPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="articles" element={<ArticleManagement />} />
              <Route path="epapers" element={<EPaperManagement />} />
              <Route path="publications" element={<PublicationsManagement />} />
              <Route path="galleries" element={<GalleryManagement />} />
              <Route path="citizen-reports" element={<CitizenReportsManagement />} />
              <Route path="advertisements" element={<AdvertisementManagement />} />
              <Route path="breaking-news" element={<BreakingNewsManager />} />
              <Route path="settings" element={<WebsiteSettings />} />
              <Route path="subscribers" element={<SubscriberManagement />} />
              <Route path="analytics" element={<Analytics />} />
            </Route>
          </Routes>
          <Toaster />
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;